module.exports = __webpack_public_path__ + "img/sphinx.b440c805.png";